import React, { useState, useEffect } from 'react';
import WindCompass from './WindCompass';
import RaceCounter from './RaceCounter';
import CountdownWidget from './CountdownWidget';
import SignalFlag from './SignalFlag';
import TideWidget from './TideWidget';
import CurrentWidget from './CurrentWidget';

const Hero = () => {
  const [windData, setWindData] = useState({ degrees: 210, speed: "18" });
  const [marineData, setMarineData] = useState({ waveHeight: "1.8", currentVelocity: "0.8", tideStatus: "FALLING" });

  useEffect(() => {
    // Fetch live wind and marine telemetry specifically for the event location (Boracay Island, Philippines)
    // Coordinates: 11.9674° N, 121.9248° E
    const fetchEventData = async () => {
      try {
        const weatherRes = await fetch('https://api.open-meteo.com/v1/forecast?latitude=11.9674&longitude=121.9248&current_weather=true&windspeed_unit=kn');
        const weatherData = await weatherRes.json();
        if (weatherData?.current_weather) {
          setWindData({
            degrees: weatherData.current_weather.winddirection,
            speed: Math.round(weatherData.current_weather.windspeed).toString()
          });
        }

        const marineRes = await fetch('https://marine-api.open-meteo.com/v1/marine?latitude=11.9674&longitude=121.9248&current=wave_height,ocean_current_velocity');
        const marineJson = await marineRes.json();

        if (marineJson?.current) {
          // Estimate tide status based on the current local hour modulo to simulate real tidal shifts
          const currentHour = new Date().getHours();
          const isRising = (currentHour % 12) < 6;

          setMarineData({
            waveHeight: marineJson.current.wave_height.toFixed(1),
            currentVelocity: marineJson.current.ocean_current_velocity.toFixed(1),
            tideStatus: isRising ? "RISING" : "FALLING"
          });
        }
      } catch (err) {
        console.error("Failed to fetch Boracay telemetry:", err);
      }
    };
    fetchEventData();
  }, []);
  const races = [
    "⛵ Boracay Summer Regatta, Philippines 🇵🇭 (May 15-17, 2026) |",
    "⛵ Sydney-Hobart Summer Regatta, Australia 🇦🇺  (Dec 26-30, 2026)",
    "⛵ Rolex Big Boat Series (Sept 16-20, 2026 - San Francisco, CA) 🇺🇸 ",
    "⛵ Mubadala New York Sail Grand Prix (May 31 – June 1, 2026 - NYC) 🇺🇸 "
  ];

  return (
    <header id="home" className="hero-header">

      <video autoPlay loop muted playsInline className="hero-video">
        <source src="/videos/hero-bg.mp4" type="video/mp4" />
      </video>

      {/* LEFT SIDE: Tactical Telemetry */}
      <div className="hero-dashboard-left">
        <WindCompass degrees={windData.degrees} speed={windData.speed} />
        <RaceCounter current={3} total={5} status="LIVE" />
        <CountdownWidget targetDate="2026-08-01T09:00:00" />
      </div>

      {/* RIGHT SIDE: Official & Environmental Status */}
      <div className="hero-dashboard-right">
        <SignalFlag flagName="AP" status="POSTPONED" />
        <TideWidget level={`${marineData.waveHeight}m`} status={marineData.tideStatus} />
        <CurrentWidget speed={marineData.currentVelocity} />
      </div>

      <div className="ticker-wrap">
        <div className="ticker">
          {/* We double the list so the scroll looks infinite/seamless */}
          {[...races, ...races].map((race, index) => (
            <div key={index} className="ticker-item">{race}</div>
          ))}
        </div>
      </div>

      <div className="hero-main-content">
        <h1>Summer Sail Regatta</h1>
        <p className="hero-subtitle" style={{ fontSize: '2rem', backgroundColor: 'rgba(40, 2, 102, 0.5)' }}>Boracay Island, Philippines 🇵🇭 2026</p>
      </div>
    </header>
  );
};

export default Hero;
